import React from 'react';
import Navbar from './Navbar';
import Particles from 'react-particles-js';
import particleParams from './ParticleParams';
import Hero from './Hero';
import About from './About';
import Work from './Work';
import Contact from './Contact';

const particles = particleParams.particles;
const interactivity = particleParams.interactivity;
const retina_detect = particleParams.retina_detect;

class App extends React.Component {
	render () {
		return (
			<div>
				<div className="particles">
					<Particles params={{particles: particles, interactivity: interactivity, retina_detect: retina_detect}} />
				</div>
				<Navbar />
				<Hero />
				<About />
				<Work />
				<Contact />
			</div>
		)
	}
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js